import { useState } from "react";
import { toast } from "react-hot-toast";
import { KudosContributor } from "../@types/KudosContributor";
import { PaginatedResponse } from "../@types/PaginatedResponse";
import {
  getKudosContributors,
  getKudosEndorsers,
  getKudosOwners,
  IKudosEndorser,
} from "../services/apis";

export const useFetchKudosMetadata = (tokenId: string) => {
  const [endorsers, setEndorsers] = useState<IKudosEndorser[]>([]);
  const [contributorsResponse, setContributorsResponse] =
    useState<PaginatedResponse>({
      data: [],
      count: 0,
      limit: 0,
      offset: 0,
    });
  const [contributors, setContributors] = useState<KudosContributor[]>([]);
  const [ownersResponse, setOwnersResponse] = useState<PaginatedResponse>({
    data: [],
    count: 0,
    limit: 0,
    offset: 0,
  });
  const [owners, setOwners] = useState<KudosContributor[]>([]);

  const fetchContributors = async (limit?: number) => {
    const response = await getKudosContributors(
      tokenId,
      contributorsResponse?.offset + contributorsResponse?.limit,
      limit ? limit : undefined,
    );
    setContributorsResponse(response);
    setContributors([...contributors, ...response.data]);
  };

  const fetchOwners = async (limit?: number) => {
    const response = await getKudosOwners(
      tokenId,
      ownersResponse?.offset + ownersResponse?.limit,
      limit ? limit : undefined,
    );
    setOwnersResponse(response);
    setOwners([...owners, ...response.data]);
  };

  const fetchEndorsements = async () => {
    const endorsersResponse = await getKudosEndorsers(tokenId);
    setEndorsers(endorsersResponse?.data);
  };

  const fetchMetadata = async () => {
    const initialNumAddressesToShow = 5;

    await fetchEndorsements();
    await fetchOwners(initialNumAddressesToShow);
    await fetchContributors(initialNumAddressesToShow);
  };

  return {
    fetchEndorsements,
    fetchOwners,
    fetchContributors,
    fetchMetadata,
    contributorsResponse,
    contributors,
    ownersResponse,
    owners,
    endorsers,
  };
};
